import React, { useState, useEffect, useRef, createContext  } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../../../../css/form.css';
import '../../../../css/TopUpBillReport.css';
import '../../../../css/datepicker.css';
import DatePicker from "react-datepicker";
import axios from "axios";
import { API } from "../../../../services/api";
import { useReactToPrint } from 'react-to-print';
import logo from '../../../../img/logo/ManeeCafeLogo.jpg';
import { format } from "date-fns";
axios.defaults.baseURL = API;

class PrintReport extends React.PureComponent {
    render() {
        function currencyFormat(num) {
            if (num !== "") {
                return Number(num).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            }
        }
        function getDate(gdate) {
            var date = new Date(gdate);
            return format(date, "dd-MM-yyyy");
          }
        const billDetails = this.props.BillDetails;
        const productList = this.props.TemProductList;
        const today = Date.now();
        let NetTotal = 0;
        let SubtTotal = 0;
        const StartDate = (new Intl.DateTimeFormat('en-US', {day: '2-digit', month: '2-digit',year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(billDetails.StartedDate));
        const EndDate = (new Intl.DateTimeFormat('en-US', {day: '2-digit', month: '2-digit',year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(billDetails.EndedDate));
        return (
            <div className="TopUpBillReportContent">
                <div className="ReportHeader">
                      <img className="profile-img" src={logo} />
                    <div className="ReportTitle">
                        <div className="titleHeader1">
                            <span>ສາທາລະນະລັດ ປະຊາທິປະໄຕ ປະຊາຊົນລາວ</span>
                        </div>
                        <div className="titleHeader2">
                            <span>ສັນຕິພາບ ເອກະລາດ ປະຊາທິປະໄຕ ເອກະພາບ ວັດທະນາຖາວອນ</span>
                        </div>
                        <div className="titleHeader2">
                            <span>**********</span>
                        </div>
                        <div className="titleHeader3">
                            <span>ລາຍງານ ບິນຂາຍ Gift Card ທີ່ຍົກເລີກ</span>
                        </div>
                        
                    </div>
                    <div className="ReportBillNo">
                        <span>ແຕ່ວັນທີ # {StartDate}</span>
                    </div>
                    <div className="PrintDate">
                        <span>ຫາວັນທີ: {EndDate}</span> 
                    </div>
                    {/* <div className="ReportLocation">
                        <span>ສາຂາ: {billDetails.LocationName}</span>
                    </div> */}
                </div>
                <div className="ReportBody">
                    <div className="ReportBodyHeader">
                    <span className="CountNumber">NO.</span>
                        <span className="BillNo">ເລກບິນ</span>
                        <span className="MemberNO">ເລກບັດ</span>
                        <span className="PaymentType">ຍອດເງິນໃນບັດ</span>
                        <span className="NetTotal">ຍອດບັດລວມ</span>
                        <span className="PaymentType">ຍອດບັດ</span>
                        <span className="NetTotal">ມື້ສາ້ງ</span>
                    </div>
                    <div className="HeadLine">
                    <div className="header-line"></div>
                    </div>
                    <div className="ReportDetail">
                        {
                            productList && productList.map((x, y) => {
                              NetTotal = Number(NetTotal) +  Number(x.TotalAmount);
                              SubtTotal = Number(SubtTotal) +  Number(x.TopUpAmount);
                              return (
                                  <div className="Items">
                                      <div className="Detail">
                                          <div className="mds">
                                              <span className="NO">{(y + 1) }</span>
                                              <td >{y + 1}</td>
                                              <span className="BillNo">{x.TopUpGiftCardID}</span>
                                              <span className="MemberNO">{x.GiftCardNO}</span>
                                              <span className="PaymentType">{x.Price}</span>
                                              <span className="TopUpAount">{currencyFormat(x.TopUpAmount)}</span>    
                                              <span className="TopUpAount">{currencyFormat(x.TotalAmount)}</span>
                                              <span className="TopUpAount">{getDate(x.CreateDate)}</span>     
                                          </div>
                                      </div>
                                  </div>
                              )
                          })
                        }
                    </div>
                     <div className="HeadLine">
                     <div className="footer-line"></div>
                    </div>
                    <div className="ReportBodyFooter">
                        <span className="Total">ລວມທັງໝົດ:</span>
                        <span className="PaidAmount">{currencyFormat(SubtTotal)}</span>
                        <span className="PaidAmount">{currencyFormat(NetTotal)}</span>
                        <span className="PaidAmount"></span>
                    </div>
                    <div className="ReportSign">
                        
                        <span className="Manager">ຜູ້ກວດກາ</span>
                        <span className="StockAdmin"></span>
                        <span className="finance">ຜູ້ຄິດໄລ່</span>
                    </div>
                </div>
            </div>
        );
    }
  }


function TopUpGiftCardBillReport() {

    function getDate(gdate) {
        const today = gdate;
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        const date = today.getDate();
        const time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
        return `${year}-${month}-${date} ${time}`;
    }

    function getDates(gdate) {
        var date = new Date(gdate);
        return format(date, "dd-MM-yyyy");
      }

  const [StartedDate, setStartedDate] = useState(null); 
  const [EndedDate, setEndedDate] = useState(null); 
  const [LocationList, setLocationList] = useState(null); 
  const [LocationID, setLocationID] = useState(""); 
  const [LocationName, setLocationName] = useState("");
  const componentRef = useRef(); 

  const [showData, setShowData] = useState([]);
  const [TransactionDetail, setTransactionDetail] = useState([]);

  const filterPassedTime = time => {
    const selectedDate = new Date(time);
    return selectedDate.getTime();
  }

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });


  const handleChangeStartedDate = event => {
    if (event)
        setStartedDate(event);
    else 
        setStartedDate(null);
}

const handleChangeEndedDate = event => {
    if (event)
        setEndedDate(event);
    else 
        setEndedDate(null);
}

const handleSelectLocation = (e) => {
  var data = LocationList.filter(function (item) {
      return item.LocationName == e.target.value
  })
  if (data.length > 0) {
      setLocationName(data[0].LocationName);
      setLocationID(data[0].LocationID);
  } else {
      setLocationName("");
      setLocationID("");
  }
};

  async function SearchTransaction() {
      var StatusID = 1;
      await axios.get(`/TopUpGiftCardBillReport/${getDate(StartedDate)}/${getDate(EndedDate)}/${StatusID}`).then((response) => {
        let Data = response?.data;
        setShowData(Data);
      }).catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    let userData = localStorage.getItem("locationData");
    if (userData) {
      let userRole = JSON.parse(userData);
      setLocationList(userRole);
    }
  }, []);

  return (
      <div className="formContent">
        <div className="Header">
          <div className="title">
              <span>ລາຍງານບິນລວມບັດ Gift Card</span>
          </div>
          <div className="txtSearch">
            <div className="StartedDate">
                <label>ແຕ່ວັນທີ: </label>
                <DatePicker className="date"
                    selected={StartedDate}
                    onChange={(e) => handleChangeStartedDate(e)}
                    showTimeSelect
                    filterTime={filterPassedTime}
                    dateFormat="dd-MM-yyyy HH:mm"
                />
            </div>
            <div className="EndedDate">
                <label >ຫາວັນທີ: </label>
                <DatePicker className="date"
                    selected={EndedDate}
                    onChange={(e) => handleChangeEndedDate(e)}
                    showTimeSelect
                    filterTime={filterPassedTime}
                    dateFormat="dd-MM-yyyy HH:mm"
                />
            </div>
            {/* <div className="Location">
                <label>ສາຂາ: </label>
                <select name="LocationID" onChange={(e) => handleSelectLocation(e)}
                    className={`input form-control`}>
                    <option
                        key={""}
                        value={""}
                    >
                        {'ເລືອກສາຂາ'}
                    </option>,
                    {LocationList && LocationList.map(item => (
                        <option
                            key={item.LocationID}
                            value={item.LocationName}
                        >
                            {item.LocationName}
                        </option>
                    ))}
                </select>
            </div> */}
            <button className="btnSearch btn btn-primary" onClick={() => SearchTransaction()}>
                ຄົ້ນຫາ
            </button>
            <button className="btnSearch btn btn-success" onClick={() => handlePrint()}>
                ພິມລາຍງານ
            </button>
          </div>
        </div>
        <div className="Body">
          <table className="styled-table">
            <thead>
              <tr key={1}>
                <th>ລ/ດ</th>
                <th>ເລກບິນ</th>
                <th>ເລກບັດ</th>
                <th>ລາຄາ</th>
                <th>ຍອດບັດລວມ</th>
                <th>ຍອດລວມ</th>
                <th>ມື້ສ້າງ</th>
              </tr>
            </thead>
            <tbody>
              {
                showData && showData.map((x, y) => {
                    return (
                      <tr key={y}>
                        <td >{y + 1}</td>
                        <td >{x.TopUpGiftCardID }</td>
                        <td >{x.GiftCardNO}</td>
                        <td >{x.Price}</td>
                        <td >{x.TopUpAmount}</td>
                        <td >{x.TotalAmount}</td>
                        <td >{getDates(x.CreateDate)}</td>
                      </tr>
                    )
                })
              }
            </tbody>
          </table>
        </div>
        <div style={{display: 'none'}}>
            <PrintReport ref={componentRef}
                    TemProductList={showData}
                    BillDetails={{"StartedDate": StartedDate, "EndedDate": EndedDate , "LocationName": LocationName}} 
            />
        </div>
      </div>
  );
};

export default TopUpGiftCardBillReport;
